// src/components/admin/nornsweave/modals/AddEventModal.js
import React from 'react';
import TimePicker from '../../../TimePicker';

function AddEventModal({ event, setEvent, onClose, onSubmit }) {
  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(e);
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-xl shadow-2xl max-w-md w-full p-6">
        <h3 className="text-2xl font-bold text-slate-800 mb-4">Add Library Event</h3>
        <p className="text-sm text-slate-600 mb-4">
          Library events are informational - they do not block bookings but help staff know what's happening.
        </p>
        <form onSubmit={handleSubmit} className="space-y-4">
          {/* Date Range Selection */}
          <div>
            <label className="block text-slate-700 text-sm font-medium mb-2">Date(s)</label>
            <div className="flex gap-4 mb-2">
              <label className="flex items-center gap-2">
                <input
                  type="radio"
                  name="dateType"
                  value="single"
                  checked={event.dateType !== 'range'}
                  onChange={() => setEvent({ ...event, dateType: 'single', endDate: '' })}
                />
                <span className="text-sm">Single day</span>
              </label>
              <label className="flex items-center gap-2">
                <input
                  type="radio"
                  name="dateType"
                  value="range"
                  checked={event.dateType === 'range'}
                  onChange={() => setEvent({ ...event, dateType: 'range' })}
                />
                <span className="text-sm">Multiple days</span>
              </label>
            </div>
            <div className="flex gap-2 items-center">
              <input
                type="date"
                required
                className="flex-1 px-3 py-2 border border-slate-300 rounded-lg"
                value={event.date}
                onChange={(e) => setEvent({...event, date: e.target.value})}
              />
              {event.dateType === 'range' && (
                <>
                  <span className="text-slate-500">to</span>
                  <input
                    type="date"
                    required
                    className="flex-1 px-3 py-2 border border-slate-300 rounded-lg"
                    value={event.endDate || ''}
                    onChange={(e) => setEvent({...event, endDate: e.target.value})}
                  />
                </>
              )}
            </div>
          </div>

          {/* Time Selection - All Day vs Specific Time */}
          <div>
            <label className="block text-slate-700 text-sm font-medium mb-2">Time</label>
            <div className="flex gap-4 mb-2">
              <label className="flex items-center gap-2">
                <input
                  type="radio"
                  name="timeType"
                  value="allDay"
                  checked={event.timeType === 'allDay'}
                  onChange={() => setEvent({ ...event, timeType: 'allDay', startTime: '', endTime: '' })}
                />
                <span className="text-sm">All day</span>
              </label>
              <label className="flex items-center gap-2">
                <input
                  type="radio"
                  name="timeType"
                  value="specific"
                  checked={event.timeType !== 'allDay'}
                  onChange={() => setEvent({ ...event, timeType: 'specific' })}
                />
                <span className="text-sm">Specific time</span>
              </label>
            </div>
            {event.timeType !== 'allDay' && (
              <div className="grid grid-cols-2 gap-4">
                <TimePicker
                  label="Start Time"
                  required
                  value={event.startTime}
                  onChange={(val) => setEvent({...event, startTime: val})}
                />
                <TimePicker
                  label="End Time"
                  required
                  value={event.endTime}
                  onChange={(val) => setEvent({...event, endTime: val})}
                />
              </div>
            )}
          </div>

          <div>
            <label className="block text-slate-700 text-sm font-medium mb-1">Event Title</label>
            <input
              type="text"
              required
              placeholder="e.g., Author Visit, Book Fair"
              className="w-full px-3 py-2 border border-slate-300 rounded-lg"
              value={event.title}
              onChange={(e) => setEvent({...event, title: e.target.value})}
            />
          </div>
          <div>
            <label className="block text-slate-700 text-sm font-medium mb-1">Affects Library</label>
            <select
              className="w-full px-3 py-2 border border-slate-300 rounded-lg"
              value={event.library}
              onChange={(e) => setEvent({...event, library: e.target.value})}
            >
              <option value="elementary">Elementary</option>
              <option value="middle">Middle School</option>
              <option value="both">Both</option>
            </select>
          </div>
          <div className="flex gap-3">
            <button
              type="button"
              onClick={onClose}
              className="flex-1 bg-slate-200 text-slate-700 py-2 rounded-lg hover:bg-slate-300"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="flex-1 bg-yellow-500 text-white py-2 rounded-lg hover:bg-yellow-600"
            >
              Add Event
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AddEventModal;
